import { render, staticRenderFns } from "./TimsDatetimepicker.vue?vue&type=template&id=045c176e&scoped=true&"
import script from "./TimsDatetimepicker.vue?vue&type=script&lang=ts&"
export * from "./TimsDatetimepicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c176e",
  null
  
)

export default component.exports